import React from 'react'
import { Link } from 'gatsby'
import classNames from 'classnames'

import Button from '../common/Button'
import Container from '../common/Container'

import { ReactComponent as LogoSvg } from './fpjs.svg'
import { PATH } from '../../constants/content'

import styles from './HeaderShort.module.scss'

interface HeaderShortProps {
  showContactSalesButton?: boolean
  isHomepage?: boolean
}

export default function HeaderShort({ showContactSalesButton = true, isHomepage }: HeaderShortProps) {
  return (
    <header
      className={classNames(styles.header, {
        [styles.noSticky]: !showContactSalesButton,
        [styles.isHomepage]: isHomepage,
      })}
    >
      <Container size='large' className={styles.root}>
        <nav className={styles.nav}>
          <Link to='/' className={styles.link} title='Logo'>
            <LogoSvg className={styles.logo} />
          </Link>
          {showContactSalesButton && (
            <Button href={PATH.contactSales} size='medium' variant='primary' className={styles.button}>
              Contact Sales
            </Button>
          )}
        </nav>
      </Container>
    </header>
  )
}
